
<script context="module">
    export const API_URL = "https://jukebox.esek.se";
</script>
